import requestAnimFrame from './raf-polyfill';
import du from './dom-utilities';

/**
 * Throttle an optimized event with requestAnimationFrame
 *
 * @param {String[]} EventNames Array of event name to throttle
 */
export default function(EventNames) {
    var throttle = function(type, name, obj = window) {
        var running = false;
        var func = function() {
            if (running) {
                return;
            }
            running = true;
             requestAnimFrame(function() {
                du.triggerEvent(obj, name);
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    EventNames.forEach((eventName) => {
        throttle(eventName, 'optimized-' + eventName);
    });
};



// WEBPACK FOOTER //
// ./src/main/js/utils/optimized-events.js